module.exports = __webpack_public_path__ + "img/edit.7112a866.svg";